import type {
  SearchApiResponse,
  SearchResultData,
  SearchResultSection,
} from "../../../@types/portalAluno";
import { CONTENT_SECTIONS } from "../../../config/portalAluno/contentSections";
import { asObject } from "../coerce";
import { mapApiItemsToCards } from "./contentCardMapper";

const SEARCH_COLLECTIONS = CONTENT_SECTIONS.filter(
  (section) => section.kind !== "destaques"
).map((section) => ({
  key: section.homeKey as keyof SearchApiResponse,
  kind: section.kind,
  route: section.route as string | undefined,
  title: section.title,
}));

const COLLECTIONS = [
  {
    key: "conteudos" as keyof SearchApiResponse,
    kind: "conteudos" as const,
    route: undefined,
    title: "Conteúdos",
  },
  ...SEARCH_COLLECTIONS,
];

export const mapSearchResponse = (
  value: unknown,
  query: string
): SearchResultData => {
  const response = asObject<SearchApiResponse>(value);

  if (!response) {
    throw new Error("A API retornou um resultado de pesquisa inválido.");
  }

  const sections = COLLECTIONS.reduce<SearchResultSection[]>(
    (result, { key, kind, route, title }) => {
      const cards = mapApiItemsToCards(response[key], kind);

      if (cards.length > 0) result.push({ cards, route, title });

      return result;
    },
    []
  );

  return {
    query,
    sections,
    total: sections.reduce((total, section) => total + section.cards.length, 0),
  };
};
